module.exports = __webpack_public_path__ + "img/hero-financials.c5d78bc9.jpg";